import { Drawer, Grid, Typography, Divider } from '@material-ui/core';
import { Button, AutoComplete, SmSpace, TextField } from 'm2m.components';
import React, { useEffect, useState } from 'react';
import { InvestidorResponse, BancoResponse, InformacoesBancariasCustodiante } from 'common/genericTypes';

interface Props {
  custodianteRazaoSocial?: string;
  bancosOptions: Array<BancoResponse>;
  open: boolean;
  isEdit: boolean;
  onClose: () => void;
  addinformacoesBancarias: (value: InformacoesBancariasCustodiante, isEdit: boolean) => void;
}

const InformacoesBancariasDrawer: React.FC<Props> = (props) => {
  const {
    custodianteRazaoSocial,
    bancosOptions,
    open,
    addinformacoesBancarias,
    onClose,
  } = props;

  const [investidor, setInvestidor] = useState<InvestidorResponse>();
  const [banco, setBanco] = useState<BancoResponse | null>(null);
  const [agencia, setAgencia] = useState<string>('');
  const [conta, setConta] = useState<string>('');

  useEffect(() => {
    if (bancosOptions && bancosOptions.length > 0 && investidor) {
      const bancoAntigo = bancosOptions.find(
        (_) => _.ispb === investidor.ispbBanco && _.shortname === investidor.razaoSocialBanco
      );
      if (bancoAntigo) {
        setBanco(bancoAntigo);
        setAgencia(investidor.agenciaBanco);
        setConta(investidor.contaBanco);
      }
    }
  }, [bancosOptions, investidor]);

  const bancosFilter = (value: string) =>
    bancosOptions.filter(
      (b) =>
        b.code.includes(value) ||
        b.fullname.toLocaleLowerCase().includes(value) ||
        b.ispb.includes(value) ||
        b.shortname.toLocaleLowerCase().includes(value)
    );

  const handleAddClick = () => {
    if (banco && agencia && conta) {
      const informacoesBancarias: InformacoesBancariasCustodiante = {
        ispbBanco: banco.ispb,
        razaoSocialBanco: banco.shortname,
        agenciaBanco: agencia,
        contaBanco: conta,
      };
      addinformacoesBancarias(informacoesBancarias, props.isEdit);
      handleClose();
    }
  };

  const handleClose = () => {
    setInvestidor(undefined);
    setBanco(null);
    setAgencia('');
    setConta('');
    onClose();
  };

  return (
    <Drawer open={open} onClose={handleClose} PaperProps={{ style: { padding: '40px', width: 465 } }} anchor="right">
      <Typography variant="h3">{props.isEdit ? ('Editar Dados Bancários do Custodiante') : ('Dados Bancários do Custodiante')}</Typography>
      <Typography variant="body2">{custodianteRazaoSocial}</Typography>
      <SmSpace />
      <Divider variant="fullWidth" />
      <SmSpace />
      <Grid container spacing={2} style={{ width: '100%' }}>
        <Grid item xs={12}>
          <AutoComplete
            label={'Banco *'}
            options={bancosOptions ?? []}
            getOptionLabel={(option: BancoResponse) => `${option.code} - ${option.shortname}`}
            value={banco || null}
            onChange={(newValue) => setBanco(newValue)}
            filterOptions={
              bancosOptions
                ? (_options: Array<BancoResponse>, state) => bancosFilter(state.inputValue.toLocaleLowerCase())
                : undefined
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextField label={'Agência'} required value={agencia} onChange={(value) => setAgencia(value)} />
        </Grid>
        <Grid item xs={12}>
          <TextField label={'Conta'} required value={conta} onChange={(value) => setConta(value)} />
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            disabled={!banco || !agencia || !conta}
            onClick={handleAddClick}
          >
            {props.isEdit ? ('Atualizar Dados Bancários') : ('Adicionar Dados Bancários')}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Button fullWidth variant="outlined" onClick={handleClose}>
            {props.isEdit ? ('Cancelar edição') : ('Continuar sem dados Bancários')}
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default InformacoesBancariasDrawer;
